module.exports = __webpack_public_path__ + "img/hotelFamily-7.0176328e.jpg";